const SkodaSecondDataInfo = () => {
    return (
        <div className="form-info-container">
            <div className="form-info">
                <p><b>Jak przetwarzamy Twoje dane?</b></p>
                <p>
                    Administratorem danych jest Volkswagen Group Polska sp. z o.o. z siedzibą w Poznaniu (61-037), ul.
                    Krańcowa 44 wpisana do Rejestru Przedsiębiorców prowadzonego przez Sąd Rejonowy w Poznaniu – Nowe
                    Miasto i Wilda, VIII Wydział Gospodarczy pod numerem KRS 0000327143, NIP 782-24-63-563, REGON
                    301062169 (VGP).
                </p>
                <p>
                    W każdej chwili możesz zrezygnować z otrzymywania Newslettera i wycofać zgody aktywując link
                    znajdujący się w stopce każdego Newslettera, czego skutkiem będzie usunięcie Twojego adresu e-mail z
                    listy dystrybucyjnej usługę Newsletter. .
                </p>
                {/*<b>Jak przetwarzamy Twoje dane?</b>*/}
                {/*<p>*/}
                {/*    <strong>MOŻESZ UDZIELIĆ TAKŻE DODATKOWYCH ZGÓD CELEM MARKETINGU PRZYSZŁEGO</strong> <br/>(ZGODY SĄ*/}
                {/*    OPCJONALNE I DOBROWOLNE, A ICH UDZIELENIE LUB ODMOWA SĄ NIEZALEŻNE OD OBSŁUGI TWOJEGO ZAPYTANIA)*/}
                {/*</p>*/}
            </div>
        </div>
    );
}

export default SkodaSecondDataInfo;
